import React from "react";
import Bubble from "@/common/UI/Bubble";
import Translator from "../hoc/Translator";

const isBenefitsPerk = (name) => {
  const trimmed = String(name || "").trim();
  return /^(benefit|benefits)$/i.test(trimmed);
};

const JobPerksBubbles = ({ perks = [], limit, onDark }) => {
  const visible = limit ? perks.slice(0, limit) : perks;
  const extra = limit && perks.length > limit ? perks.length - limit : 0;

  return (
    <>
      {visible.map((perk, index) => (
        <Bubble
          color="1"
          onDark={onDark}
          keepColor={isBenefitsPerk(perk.name)}
          key={perk.id ?? "Perk" + index}
        >
          <Translator>{perk.name}</Translator>
        </Bubble>
      ))}
      {extra > 0 && (
        <Bubble color="1" onDark={onDark}>
          +{extra}
        </Bubble>
      )}
    </>
  );
};

export default JobPerksBubbles;
